export const tipoModeloImpressaoFormat = {
  ETIQUETA: 'Etiqueta',
  REQUERIMENTO: 'Requerimento'
};

export const tipoOptions = [
  { label: 'Etiqueta', value: 'ETIQUETA' },
  { label: 'Requerimento', value: 'REQUERIMENTO' }
];
